<template>
    <div v-if="!isGuest" id="image-tools" class="hide">
        <div class="left">
            <div id="btn-add-candidate" v-show="activeImageId">
                <v-btn class="color-gray rounded-xl" outlined>
                    <v-icon :class="{ disabled: !canCreateAssets || blockLoading }" color="#ababab"
                            class="material-icons">add
                    </v-icon>
                    Add to My Selections
                </v-btn>
            </div>
        </div>

        <div class="middle">
            <i id="btn-semi-fullscreen" class="material-icons" data-tippy-content="Full Browser View">aspect_ratio</i>
            <i id="btn-fullscreen" class="material-icons" data-tippy-content="Full Screen View">fullscreen</i>
            <BackgroundColorPicker class="ml-5" />
        </div>

        <div class="right">
            <i id="btn-rotate-right" class="material-icons" data-tippy-content="Rotate Image">rotate_right</i>
            <i id="btn-reset-scene" :class="{ disabled: !canUseColorGradingTools || blockLoading }"
               class="material-icons"
               data-tippy-content="Reset All"
            >
                invert_colors_off
            </i>
            <i id="btn-split-view" class="material-icons" data-tippy-content="Split View">compare</i>
        </div>
    </div>
</template>

<script>
import BackgroundColorPicker from '@/components/app/ui/BackgroundColorPicker';

import CanMixin from '@/mixins/CanMixin';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Tools',
    mixins: [CanMixin],

    components: {
        BackgroundColorPicker
    },

    computed: {
        ...mapState('Projects', ['image']),
        ...mapState('App', ['IDT', 'blockLoading']),
        ...mapGetters('User', ['isGuest']),
        ...mapState('Projects', {
            activeImageId: 'image',
        }),

    }

};
</script>

<style lang="scss" scoped>
.left, .middle, .right {
	display: flex;
	align-items: center;
	gap: 12px;
}
</style>
